import {sourceActionTypes} from '../_constants';

export function uploads(state = {}, action) {
  switch (action.type) {

    // get upload-url request
    case sourceActionTypes.GET_UPLOAD_PACKET_REQUEST:
      return {
        packet: {
          isLoading: true,
        }
      };

    // get upload-url success
    case sourceActionTypes.GET_UPLOAD_PACKET_SUCCESS:
      return {
        packet: {
          isLoaded: true,
          details: action.packet,
        }
      };

    // get upload-url failure
    case sourceActionTypes.GET_UPLOAD_PACKET_FAILURE:
      return {
        packet: {
          isError: true,
        }
      };

    // upload source request
    case sourceActionTypes.UPLOAD_SOURCE_REQUEST:
      return {
        ...state,
        deliverable : {
          isUploading: true,
        }
      }

    // upload source success
    case sourceActionTypes.UPLOAD_SOURCE_SUCCESS:
      return {
        ...state,
        deliverable : {
          isUploaded: true,
          url: action.url,
        }
      }

    // upload source failure
    case sourceActionTypes.UPLOAD_SOURCE_FAILURE:
      return {
        ...state,
        deliverable : {
          isError: true,
          details: action.error,
        }
      }

    // reset uploads information
    case sourceActionTypes.UPLOAD_SOURCE_RESET:
      return {}

    default:
      return state
  }
}